import styled from "styled-components";
import {
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";

export const MiniCtaWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 15px 0px 70px 0px;
	@media only screen and (max-width: ${TABLET_BP}px) {
		padding: 15px 0px 70px 0px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 15px 24px 70px 24px;
	}
`;

export const MiniCta = styled.div`
	display: flex;
	width: 645px;
	flex-direction: column;
	align-items: center;
	padding: 35px 0px;
	background: ${(props) => props.backgroundColor};
	border: 1px solid ${(props) => props.borderColor};
	p {
		margin: 0px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
		padding: 40px 0px 55px;
		border-radius: 3px;
	}
`;

export const Header = styled.h2`
	width: 400px;
	font-size: 24px;
	font-weight: ${FONT_WT_MEDIUM};
	text-align: center;
	margin: 0px;
	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 295px;
	}
`;

export const Description = styled.span`
	width: 335px;
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	text-align: center;
	margin: 20px 0px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 240px;
		font-size: 16px;
		line-height: 1.69;
	}
`;
